(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["executive-gift-message"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('executive-gift-message')) {
    class ExecutiveGiftMessage extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-card-toggle]');
        this.fields = this.querySelector('[data-card-fields]');
        this.inputs = Array.from(this.querySelectorAll('[data-card-input]'));
        this.requiredInputs = Array.from(this.querySelectorAll('[data-card-required]'));
        this.occasion = this.querySelector('[data-card-occasion]');
        this.message = this.querySelector('[data-card-message]');
        this.count = this.querySelector('[data-card-count]');
        this.helpButton = this.querySelector('[data-help-write]');

        this.templates = {
          'Congratulations': 'Congratulations on this exciting milestone. Wishing you continued success and much to celebrate in the chapter ahead.',
          'Birthday': 'Wishing you a wonderful birthday and a year ahead filled with happiness, success, and plenty to celebrate.',
          'Thank You': 'With sincere thanks and appreciation. It is a pleasure to work with you, and we are grateful for your trust and partnership.',
          'Welcome to Ownership': 'Congratulations on this exciting new chapter of ownership. Wishing you great success and many memorable milestones ahead.',
          'Get Well': 'Thinking of you and sending warm wishes for comfort, strength, and a smooth recovery.',
          'Client Appreciation': 'With sincere appreciation for your trust and partnership. We are grateful for the opportunity to work with you and look forward to what is ahead.',
          'Welcome to the Team': 'Welcome to the team. We are so glad you are here and look forward to all we will accomplish together.',
          'Other': 'Thinking of you and sending our warmest wishes. We hope you enjoy this gift with our compliments.'
        };

        this.toggle?.addEventListener('change', () => this.updateState());
        this.message?.addEventListener('input', () => this.updateCount());
        this.helpButton?.addEventListener('click', () => this.writeMessage());

        requestAnimationFrame(() => this.updateState());
      }

      get productForm() {
        const formId = this.dataset.formId;
        return formId ? document.getElementById(formId) : null;
      }

      updateState() {
        const enabled = Boolean(this.toggle?.checked);
        if (this.fields) this.fields.hidden = !enabled;

        this.inputs.forEach((input) => {
          input.disabled = !enabled;
        });

        this.requiredInputs.forEach((input) => {
          input.required = enabled;
        });

        const acceleratedCheckout = this.productForm?.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
        if (acceleratedCheckout instanceof HTMLElement) {
          acceleratedCheckout.hidden = enabled;
        }

        if (enabled) {
          requestAnimationFrame(() => this.querySelector('input[name="properties[Card recipient]"]')?.focus());
        }

        this.updateCount();
      }

      updateCount() {
        if (!this.message || !this.count) return;
        this.count.textContent = `${this.message.value.length} / ${this.message.maxLength}`;
      }

      writeMessage() {
        if (!this.message || !this.occasion) return;
        const draft = this.templates[this.occasion.value] || this.templates.Other;
        this.message.value = draft;
        this.message.dispatchEvent(new Event('input', { bubbles: true }));
        this.message.focus();
      }
    }

    customElements.define('executive-gift-message', ExecutiveGiftMessage);
  }
  } catch(e) { console.error(e); }
})();

})();
